import React, { useState } from 'react';
import { Card, CardBody, Col, Container, Input, Label, Row, Button, Form, FormFeedback, Spinner } from 'reactstrap';
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth.js";

//redux

import { Link } from "react-router-dom";
import withRouter from "@velzon/components/withRouter.js";
// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

import postHub from "../../assets/images/PostHubb-logo.svg";
import useRouter from '@velzon/Hooks/useRouter.js';
import { login } from 'api/authentication/auth.js';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { setUser } from 'store/reducer/AuthSlice/index.js';

const Login = () => {
  const router = useRouter();
  const dispatch = useDispatch();

  const [userLogin] = useState([]);
  const [passwordShow, setPasswordShow] = useState(false);
  const [loading, setLoading] = useState(false)

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    validateOnMount: true,

    initialValues: {
      email: userLogin.email,
      password: userLogin.password
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Please enter a valid email address")
        .matches(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/, "Must be a valid email address")
        .required("Please Enter Your Email"),
      password: Yup.string().required("Please Enter Your Password")
    }),
    onSubmit: async (values) => {
      setLoading(true)
      try {
        const payload = {
          email: values.email,
          password: values.password
        }
        const response = await login(payload);

        localStorage.setItem('token', true);

        dispatch(setUser({
          user: response.user
        }));

        toast.success(response.message)

        router.push('/dashboard');
      } catch (error) {
        toast.error(error?.response?.data?.message || 'Login failed');
      } finally{
        setLoading(false)
      }
    }
  });

  document.title = 'Login'

  return (
    <React.Fragment>
      <ParticlesAuth>
        <div className="auth-page-content mt-lg-5">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="text-center mt-sm-5 mb-4 text-white-50">
                  <div>
                    <Link to="/" className="d-inline-block auth-logo">
                      <img src={postHub} alt="" height="100" />
                    </Link>
                  </div>
                  {/* <p className="mt-3 fs-15 fw-medium">Premium Admin & Dashboard Template</p> */}
                </div>
              </Col>
            </Row>

            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="mt-4">
                  <CardBody className="p-4">
                    <div className="text-center mt-2">
                      <h5 className="text-primary">Welcome Back !</h5>
                      <p className="text-muted">Sign in to continue</p>
                    </div>
                    {/* {error && error ? (<Alert color="danger"> {error} </Alert>) : null} */}
                    <div className="p-2 mt-4">
                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                        action="#">

                        <div className="mb-3">
                          <Label htmlFor="email" className="form-label">Email</Label>
                          <Input
                            name="email"
                            className="form-control"
                            placeholder="Enter email"
                            type="email"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.email || ""}
                            invalid={
                              validation.touched.email && validation.errors.email ? true : false
                            }
                          />
                          {validation.touched.email && validation.errors.email ? (
                            <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-3">
                          <div className="float-end">
                            <Link to="/forgot-password" className="text-muted">Forgot password?</Link>
                          </div>
                          <Label className="form-label" htmlFor="password-input">Password</Label>
                          <div className="position-relative auth-pass-inputgroup mb-3">
                            <Input
                              name="password"
                              value={validation.values.password || ""}
                              type={passwordShow ? "text" : "password"}
                              autoComplete='new-password'
                              className="form-control pe-5"
                              placeholder="Enter Password"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              invalid={
                                validation.touched.password && validation.errors.password ? true : false
                              }
                            />
                            {validation.touched.password && validation.errors.password ? (
                              <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                            ) : null}
                            {/* <button className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted" type="button" id="password-addon" onClick={() => setPasswordShow(!passwordShow)}><i className="ri-eye-fill align-middle"></i></button> */}
                            {/* {!validation.errors.password && <button className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted" type="button" id="password-addon" onClick={() => setPasswordShow(!passwordShow)}><i className="ri-eye-fill align-middle"></i></button>} */}
                            {!validation.errors.password && <button
                              type="button"
                              className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                              onClick={() => setPasswordShow(!passwordShow)}
                              style={{ zIndex: 10 }}
                            >
                              {/* {passwordShow ? <i className="ri-eye-line align-middle"></i> : <i className="ri-eye-off-line align-middle"></i>} */}
                              <i
                                className={
                                  passwordShow
                                    ? "ri-eye-line align-middle"
                                    : "ri-eye-off-line align-middle"
                                }
                              />
                            </button>
                            }
                          </div>
                        </div>

                        {/* <div className="form-check">
                          <Input
                            className="form-check-input"
                            type="checkbox" value=""
                            id="auth-remember-check"
                          />
                          <Label className="form-check-label" htmlFor="auth-remember-check">Remember me</Label>
                        </div> */}

                        <div className="mt-4">
                          <Button
                            disabled={loading || !validation.isValid}
                            color="danger"
                            className="btn btn-danger w-100"
                            type="submit">
                            {loading ? (
                              <>
                                <Spinner size="sm" className="me-2" />
                              </>
                            ) : (
                              "Sign In"
                            )}
                          </Button>

                        </div>

                      </Form>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </ParticlesAuth>
    </React.Fragment>
  );
};

export default withRouter(Login);